interface RejectCommentModalProps {
  comment: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onClose: () => void;
}

export default function RejectCommentModal({
  comment,
  onChange,
  onSubmit,
  onClose,
}: RejectCommentModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-base font-semibold text-gray-800 mb-3">Reject Job</h2>
        <textarea
          className="w-full border rounded-md p-2 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-red-400"
          rows={4}
          placeholder="Enter rejection comment..."
          value={comment}
          onChange={(e) => onChange(e.target.value)}
        />
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-1.5 text-sm rounded border text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={!comment.trim()}
            className="px-4 py-1.5 text-sm rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
